/**
 * @description This dictionary provides config for how to display UI for claim to collet claims.benefitClaims.values
 *
 * @prop {string} componentName (mandatory) - What component to display, right now we have only one TemplateTable
 * @prop {boolean} hasMultiRows - Some components support adding lines dynamically, this is a flag to allow that
 * @prop {string} unit (mandatory) - this is being passed to backend and backend does calcluations based on this, it's important
 * @prop {string} amountLimit - for validation - component TemaplteTable has validate method that includes logic for this validation, it's checking reamining amount against approved amount
 * @prop {string} occurenceLimit - for validation - in case we have more rows in the table, it's checking whether there is more rows than allowed (e.g. max number of days is 180) so when there is 190 rows it will trigger error
 * @prop {string} remainingLimit - for validation - checking if remaining amount is less than 0; this validation is in TemplateTable and also in ClaimBenefits component
 */

const dictionary = benefitId => {
	const dictionary = {
		// perDay
		medical_hospital_room_and_board: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "day",
			amountLimit: "perDay",
			occurrenceLimit: "maxDayPerPolicyYear"
		},
		medical_doctors_visit_fee: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "day",
			amountLimit: "perDay",
			occurrenceLimit: "maxDayPerPolicyYear"
		},
		medical_intensive_care: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "day",
			amountLimit: "perDay",
			occurrenceLimit: "maxDayPerPolicyYear"
		},

		// perPolicyYear
		medical: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear"
		},
		medical_miscellaneous_charges: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear"
		},
		medical_specialist_consultations_and_visits: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear"
		},
		medical_prescribed_advanced_diagnostic_imaging_tests: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear",
			coInsurance: "coInsurance"
		},
		medical_prescribed_non_surgical_cancer_treatment: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear"
		},
		medical_psychiatric_treatment: {
			componentName: "TemplateTable",
			hasMultiRows: false,
			unit: "policyYear",
			remainingLimit: "perPolicyYear"
		},
		// perSurgery
		medical_anaesthetists_fee_complex: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_anaesthetists_fee_major: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_anaesthetists_fee_intermediate: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_anaesthetists_fee_minor: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_operating_room_complex: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_operating_room_major: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_operating_room_intermediate: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_operating_room_minor: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_surgeons_fee_complex: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_surgeons_fee_major: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			amountLimit: "perSurgery",
			unit: "surgery"
		},
		medical_surgeons_fee_intermediate: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		},
		medical_surgeons_fee_minor: {
			componentName: "TemplateTable",
			hasMultiRows: true,
			unit: "surgery",
			amountLimit: "perSurgery"
		}
	}

	// Default is used when benefit is not find in the dictionary
	const defaultTemplate = {
		componentName: "TemplateTable",
		hasMultiRows: false
	}

	return dictionary[benefitId] ? dictionary[benefitId] : defaultTemplate
}

export default dictionary
